// Helper to parse rate limit errors
export function isRateLimitError(message: string): boolean {
	const lower = message.toLowerCase()
	return lower.includes('max number') || lower.includes('rate') || lower.includes('wait')
}

// Helper to parse OTP verification errors
export function parseOtpError(message: string): string {
	const lower = message.toLowerCase()
	if (lower.includes('invalid') || lower.includes('incorrect') || lower.includes('wrong')) {
		return 'Invalid code. Please check and try again.'
	}
	if (lower.includes('expired')) {
		return 'Code expired. Please request a new one.'
	}
	return 'Verification failed. Please try again.'
}
